// extracted by mini-css-extract-plugin
export default {"userManagementBlock":"AdminManagementPage_userManagementBlock__IOp6K","innerBlockHeader":"AdminManagementPage_innerBlockHeader__0PvmB"};